/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { adjustPercent } from 'services/Calculation';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { isRetirementAdvisoryServiceClient } from 'state/customer/CustomerSelectors';
import { hasMutualFunds, hasCollegeSavings } from 'state/view/ViewSelectors';
import { getAccounts } from 'state/account/AccountSelectors';
import { getPerformanceInceptionReturn } from 'state/performance/PerformanceSelectors';
import { getTotalPerformance } from 'services/Rest';

const AggregatePerformanceDataProvider = (WrappedComponent) => {
  class AggregatePerformanceData extends Component {
    state = {
      hasAccounts: false,
      isLoading: false
    };

    componentDidUpdate() {
      const {
        accounts,
        requestStatus: { totalPerformance }
      } = this.props;
      const { hasAccounts, isLoading } = this.state;
      const isReceived = totalPerformance === REQUEST_STATES.received;

      if (!hasAccounts && accounts && accounts.length > 0) {
        this.setState({ hasAccounts: true });
      } else if (hasAccounts && !isLoading && !isReceived) {
        this.setState({ isLoading: true }, () => getTotalPerformance(accounts));
      } else if (isLoading && isReceived) {
        this.setState({ isLoading: false });
      }
    }

    render() {
      const { inceptionReturn, showTotalPerformance, requestStatus } =
        this.props;

      const { isLoading } = this.state;

      const data = {
        showTotalPerformance,
        inceptionReturn
      };

      return (
        <WrappedComponent
          data={data}
          isLoading={isLoading}
          hasError={requestStatus.totalPerformance === REQUEST_STATES.error}
        />
      );
    }
  }
  const mapStateToProps = (state) => ({
    accounts: getAccounts(state),
    inceptionReturn: adjustPercent(getPerformanceInceptionReturn(state)),
    requestStatus: getRequestStatus(state),
    showTotalPerformance:
      (hasMutualFunds(state) || hasCollegeSavings(state)) &&
      !isRetirementAdvisoryServiceClient(state)
  });
  return connect(mapStateToProps)(AggregatePerformanceData);
};

export default AggregatePerformanceDataProvider;
